import React, {useState, useEffect} from 'react';
import {Typography} from '@mui/material';
import '../../../StandardReports.scss';

import {ISelectItem} from '../../../../../../shared/types';
import ArrSingleSelectDropdown from '../../../../../common/arr-select-dropdown/ArrSingleSelectDropdown';
type ExportFormatProps = {
  label: string;
  dropdownItem: ISelectItem[];
  selectedValue: ISelectItem | null;
  onChange?: (value: ISelectItem | null) => void;
};

const ExportFormat: React.FC<ExportFormatProps> = ({
  label,
  dropdownItem,
  selectedValue,
  onChange,
}) => {
  const [selectedItem, setSelectedItem] = useState<ISelectItem | null>(
    selectedValue
  );

  useEffect(() => {
    setSelectedItem(selectedValue);
  }, [selectedValue]);

  const handleSelectionChange = (item: ISelectItem | null) => {
    if (onChange) {
      onChange(item);
    }
    setSelectedItem(item);
  };

  return (
    <div
      className="export-format-wrapper"
      data-testid={`export-format-div-${label}`}
    >
      <div
        className="label-container"
        data-testid={`export-format-div-btn-${label}`}
      >
        {' '}
        <Typography
          className="typo-text body3_size"
          data-testid={`export-format-label-${label}`}
        >
          {label}
        </Typography>
      </div>
      <div
        className="dropdown-container"
        data-testid={`export-format-div-button-${label}`}
      >
        <ArrSingleSelectDropdown
          selectedValues={selectedItem}
          dropdownLabel={''}
          sizeVariant="medium"
          dropdownItems={dropdownItem}
          dropdownItemKey="id"
          dropdownItemDisplay="name"
          onSelectionChange={handleSelectionChange}
          searchable
          showNoResultsText
          dataTestId={`asd-export-format-selectedItem-${label}`}
        />{' '}
      </div>
    </div>
  );
};

export default ExportFormat;
